import { i18n } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import * as React from 'react';
import { connect } from 'react-redux';
import Rest from '../../webapi/Rest';
import ConfermaNuovaVersioneDoc from './ConfermaNuovaVersioneDoc.jsx';
import DocumentiActions from './DocumentiActions';
import DocumentTab from './DocumentTab.jsx';
import PreviewTab from './PreviewTab.jsx';
import TabelaDataSource from './TabelaDataDource.jsx';

class NuovoDoc extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Upload.jsx] ";
        this.salvaDoc = this.salvaDoc.bind(this);
        this.modificaDoc = this.modificaDoc.bind(this);
        this.annullaModificaDoc = this.annullaModificaDoc.bind(this);
        this.elimDoc = this.elimDoc.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.preview = this.preview.bind(this);
        this.showConfermaNuovaVersione = this.showConfermaNuovaVersione.bind(this);
        this.annullaModificaOTornaIndietro = this.annullaModificaOTornaIndietro.bind(this);
        this.pubblicaDocumento = this.pubblicaDocumento.bind(this);
        this.isDisabled = this.isDisabled.bind(this);
        this.isChecked = this.isChecked.bind(this);

        this.state = {
            showConfirmSalvaDoc: false
        };
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount')
        this.props.getDataSourceLista();

        if (this.props.history.location && this.props.history.location.state && this.props.history.location.state.from !== 'dataSource/create') {

            this.props.resetDocTab();
            if (this.props.history.location && this.props.history.location.state && this.props.history.location.state.stato !== 'nuovo') {
                this.props.setIsAlreadyExistingDoc(true);
            } else {
                this.props.setIsAlreadyExistingDoc(false);
            }
        } else {
            this.props.setIsAlreadyExistingDoc(true);
        };

    }

    changeSelectedTab(idTab) {
        this.props.changeSelectedTab(idTab);
    }

    showConfermaNuovaVersione() {
        if (!this.props.showConfermaNuovaVersione) {
            this.props.toggleShowConfermaNuovaVersione();
        }
    }

    salvaDoc() {
        if (this.props.validationDocument()) {
            this.setState({ showConfirmSalvaDoc: true });
        }
    }



    salvaDocum() {
        this.props.salvaDoc().then(
            resolve => {
                this.setState({ showConfirmSalvaDoc: false })
                this.props.setIsInEditMode(false);
                this.props.setIsAlreadyExistingDoc(true);
                this.props.getDocumentById(resolve.id);
                this.props.setIdDocumentoOrigine(resolve.id);
                this.props.updateIdUltimaVersioneDocumento(resolve.id);
            }
        )
    }

    modificaDoc() {
        this.props.inizializzaModificaDocument().then(
            resolve => {
                this.props.setIsInEditMode(true);
            }
        )
    }

    annullaModificaOTornaIndietro() {
        if ((this.props.isAlreadyExistingDoc && !this.props.isInEditMode) || (!this.props.isAlreadyExistingDoc && !this.props.isInEditMode)) {
            if (!this.props.versioniDoc || this.props.versioniDoc.length == 0) {
                this.props.history.push('/documenti');
            }
            else {
                this.props.history.push('/documentiDetails');
            }
        }
        else {
            this.annullaModificaDoc();
        }
    }

    annullaModificaDoc() {
        this.props.setIsInEditMode(false);
    }

    elimDoc() {
        this.props.eliminaDoc().then(
            resolve => {
                this.props.history.goBack();
            }
        )
    }

    handleChange(id, value, tipo) {
        let validation = this.state.validation;
        if (validation.has(id)) {
            validation.delete(id);
            this.setState({ validation: validation });
        }
        this.props.handleChangeDoc(id, value, tipo);
    }

    componentWillUnmount() {
        this.props.setIsInEditMode(false);
        this.props.setIsAlreadyExistingDoc(false);
        let pathToGo = this.props.history.location.pathname;
        if (pathToGo.includes('dataSource/create'))
            console.log('unmounting');
        else
            this.props.resetDoc();
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
        if (nextProps.documento && nextProps.documento.pubblicato) {
            this.setState({ pubblciato: nextProps.documento.pubblicato });
        }
    }

    preview() {
        this.props.preview().then(
            resolve => {
                // this.props.getDocumentById(this.props.nuovoDoc.id)
            }
        )
    }

    nuovaVersioneDoc() {
        console.log(this.componentName + " nuovaVersioneDoc: " + (this.idDocumento));
        this.props.inizializzaNuovaVersioneDocumento().then( //todo posso rimuovere?
            resolve => {
                this.showConfirmPanelVersione();
            }, reject => {
                console.log(this.componentName + " inizializzaNuovaVersioneDocumento KO ");
            }
        )
    }

    toggleConfirmPanelVersione() {
        console.log(this.componentName + " toggleConfirmPanelVersione: ");
        this.setState({ showConfirmVersione: !this.state.showConfirmVersione })
    }

    pubblicaDocumento() {
        console.log("Start pubblicaDocumento");
        if (!this.props.documento.pubblicato || this.props.documento.pubblicato !== 1) {
            this.props.pubblicaDocumento(this.props.documento.id);
            this.props.setConfirmPublicDoc(false);
        }
    }

    isDisabled() {
        if (!this.props.documento || this.props.documento.id !== this.props.idUltimaVersioneDoc
            || (this.props.documento.hasOwnProperty('pubblicato') && this.props.documento.pubblicato == 1)) {
            return true;
        }
        return false;
    }

    isChecked() {
        if (this.props.documento.hasOwnProperty('pubblicato')) {
            return this.props.documento.pubblicato == 1;
        }
    }

    render() {
        const { nuovoDoc, handleChangeDoc, isAlreadyExistingDoc, isInEditMode } = this.props;
        const baseUrl = Rest.restBaseurl;

        return (

            <div className="mt-3">
                <agui.aCard>
                    <agui.aCardHeader>
                        <agui.LineBar>
                            <agui.LineBarGroup>
                                <p>{isAlreadyExistingDoc ? (isInEditMode ? i18n('ARM_CORE_PRINT.MODIFICA_DOCUMENTO', `Modifica Documento con id ${nuovoDoc.id}`) : i18n('ARM_CORE_PRINT.DETTAGLIO_DOCUMENTO', `Dettaglio di Documento con id ${nuovoDoc.id}`)) : i18n('ARM_CORE_PRINT.NUOVO_DOCUMENTO', 'Nuovo Documento')}</p>
                            </agui.LineBarGroup>
                            {isAlreadyExistingDoc && !isInEditMode ?
                                <agui.LineBarGroup right={true}>
                                        <agui.aToggle
                                            label={i18n('ARM_CORE_PRINT.PUBBLICA', 'Pubblica')}
                                            checked={this.isChecked()}
                                            disabled={this.isDisabled()}
                                            onChange={() => { this.props.setConfirmPublicDoc(true) }}
                                        >
                                        </agui.aToggle>
                                </agui.LineBarGroup>
                                : <></>}
                        </agui.LineBar>
                    </agui.aCardHeader>
                    <br />

                    <agui.aCardBody className='nuovoDoc'>
                        <div>

                            <ul className="nav nav-tabs ml-3 main-tabs" id="myTab" role="tablist">
                                <li className="active" >
                                    <a className={this.props.tabSelected === "doc-tab" ? "nav-link active" : "nav-link"} id="doc-tab" data-toggle="tab" href="#docTab" role="tab" aria-controls="docTab" aria-selected="true" onClick={() => this.changeSelectedTab('doc-tab')} >{i18n('ARM_CORE_PRINT.DOCUMENTI', 'Documenti')}</a>
                                </li>
                                <li className="nav-item">
                                    <a className={this.props.tabSelected === "dataSource-tab" ? "nav-link active" : "nav-link"} id="dataSource-tab" data-toggle="tab" href="#dataSourceTab" role="tab" aria-controls="dataSourceTab" aria-selected="true" onClick={() => this.changeSelectedTab('dataSource-tab')}>{i18n('ARM_CORE_PRINT.DATASOURCE', 'Data Source')}</a>
                                </li>
                                {isAlreadyExistingDoc && !isInEditMode &&
                                    <li className="nav-item">
                                        <a className={this.props.tabSelected === "preview-tab" ? "nav-link active" : "nav-link"} id="preview-tab" data-toggle="tab" href="#previewTab" role="tab" aria-controls="previewTab" aria-selected="true" onClick={() => this.changeSelectedTab('preview-tab')}>{i18n('ARM_CORE_PRINT.SHARED.PREVIEW', 'Preview')}</a>
                                    </li>
                                }
                            </ul>

                            <div className="tab-document-content" id="TabDocumentContent">

                                <div className={this.props.tabSelected === 'doc-tab' ? 'tab-pane active' : 'tab-pane d-none'} id="doc-tab" role="tabpanel" aria-labelledby="doc-tab">
                                    <DocumentTab />
                                </div>

                                <div className={this.props.tabSelected === 'dataSource-tab' ? 'tab-pane active mr-3' : 'tab-pane d-none'} id="dataSource-tab" role="tabpanel" aria-labelledby="dataSource-tab">
                                    {/* <table ref="ListDataSource" /> */}
                                    <agui.aButton disabled={isAlreadyExistingDoc ? (isInEditMode ? false : true) : false} className="mt-3" bs='primary' icon="fa fa-plus" onClick={() => this.props.history.push('/dataSource/create')} inline={true} >{i18n('ARM_CORE_PRINT.SHARED.NUOVO_DATASOURCE', 'Nuovo')}</agui.aButton>
                                    <TabelaDataSource history={this.props.history} disabled={isAlreadyExistingDoc ? (isInEditMode ? false : true) : false} />
                                </div>

                                {isAlreadyExistingDoc && !isInEditMode &&
                                    <div className={this.props.tabSelected === 'preview-tab' ? 'tab-pane active mr-3' : 'tab-pane d-none'} id="preview-tab" role="tabpanel" aria-labelledby="preview-tab">
                                        <PreviewTab />
                                    </div>
                                }
                            </div>
                        </div>
                        <agui.AskConfirm
                            show={this.props.showConfirmPublicDoc}
                            options={{
                                title: i18n('ARM_CORE_PRINT.DETTAGLIO.PUBBLICA_TITOLO', 'Publica documento'),
                                message: i18n('ARM_CORE_PRINT.DETTAGLIO.PUBBLICA_DESCRIZIONE', 'Sei sicuro di voler pubblicare il documento?'),
                                warning: true,
                                yes: i18n('ARM_CORE_PRINT.SHARED.SI', 'Si'),
                                no: i18n('ARM_CORE_PRINT.SHARED.ANNULLA', 'Annulla')
                            }}
                            onConfirm={() => {
                                this.pubblicaDocumento();
                            }}
                            onCancel={() => this.props.setConfirmPublicDoc(false)}
                        />
                        <agui.AskConfirm
                            show={this.state.showConfirmSalvaDoc}
                            options={{
                                title: i18n('ARM_CORE_PRINT.DETTAGLIO.SALVA_DOCUMENTO_TITOLO', 'Salva Documento'),
                                message: i18n('ARM_CORE_PRINT.DETTAGLIO.SALVA_DOCUMENTO_DESCRIZIONE', 'Confermi il salvataggio del documento?'),
                                warning: true,
                                yes: i18n('ARM_CORE_PRINT.SHARED.SI', 'Si'),
                                no: i18n('ARM_CORE_PRINT.SHARED.ANNULLA', 'Annulla')
                            }}
                            onConfirm={() => {
                                this.salvaDocum();
                            }}
                            onCancel={() => this.setState({ showConfirmSalvaDoc: false })}
                        />

                    </agui.aCardBody >

                    <agui.aCardFooter>
                        <agui.LineBar>
                            <agui.LineBarGroup>
                                {
                                    !isAlreadyExistingDoc || isInEditMode ?
                                        <agui.aButton bs='primary'
                                            icon="fas fa-save"
                                            onClick={() => this.salvaDoc()}>
                                            {i18n('ARM_CORE_PRINT.MANAGE.SALVA', 'Salva')}
                                        </agui.aButton>
                                        : null
                                }

                                {
                                    isAlreadyExistingDoc && !isInEditMode ?

                                        this.props.tabSelected === "preview-tab" ?
                                            <agui.aButton bs='primary'
                                                className='mt-3'
                                                onClick={() => this.preview()}>
                                                {i18n('ARM_CORE_PRINT.SHARED.PREVIEW', 'STAMPA')}
                                            </agui.aButton>
                                            :
                                            <>
                                                <agui.aButton bs='primary'
                                                    disabled={this.props.documento.id !== this.props.idUltimaVersioneDoc || this.props.documento.pubblicato === 1}
                                                    icon='fas fa-edit'
                                                    className='mr-3'
                                                    onClick={() => this.modificaDoc()}>
                                                    {i18n('ARM_CORE_PRINT.SHARED.MODIFICA', 'Modifica')}
                                                </agui.aButton>

                                                <agui.aButton bs='primary'
                                                    disabled={this.props.documento.id !== this.props.idUltimaVersioneDoc}
                                                    icon='fas fa-plus'
                                                    className='mr-3'
                                                    onClick={() => this.showConfermaNuovaVersione()}>
                                                    {i18n('ARM.CORE.PRINT.VERSION', 'Versione')}
                                                </agui.aButton>

                                                <agui.aButton
                                                    disabled={this.props.documento.id !== this.props.idUltimaVersioneDoc || this.props.documento.pubblicato === 1}
                                                    icon='fas fa-trash-alt'
                                                    onClick={this.elimDoc}
                                                    askConfirm={i18n('ARM_CORE_PRINT.DS.ELIMINA_DS_CONFIRM', 'Sei sicuro di voler procedere con eliminazione?')}>
                                                    {i18n('ARM_CORE_PRINT.SHARED.ELIMINA', 'Elimina')}
                                                </agui.aButton>
                                            </>
                                        : null
                                }
                            </agui.LineBarGroup>
                            <agui.LineBarGroup right={true}>
                                <agui.aButton bs='secondary'
                                    onClick={() => this.annullaModificaOTornaIndietro()}
                                >
                                    {
                                        isAlreadyExistingDoc && !isInEditMode ? i18n('ARM_CORE_PRINT.SHARED.INDIETRO', 'Indietro') : i18n('ARM_CORE_PRINT.SHARED.ANNULLA', 'Annulla')
                                    }
                                </agui.aButton>
                                <agui.aButton bs="secondary" className="mr-2" onClick={() => this.props.history.push({ pathname: '/documenti' })} >{i18n('ARM_CORE_PRINT.TORNA_ALLA_LISTA', 'Torna alla lista')}</agui.aButton>
                            </agui.LineBarGroup>
                        </agui.LineBar>
                    </agui.aCardFooter>
                </agui.aCard >

                <ConfermaNuovaVersioneDoc />

            </div >
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {

        handleChangeDoc(id, value, tipo) {
            return dispatch(DocumentiActions.handleChangeDoc(id, value, tipo));
        },
        salvaDoc() {
            return dispatch(DocumentiActions.salvaDoc());
        },
        removeFile(fileIdx, name) {
            return dispatch(DocumentiActions.removeFile(fileIdx, name));
        },
        changeSelectedTab(idTab) {
            return dispatch(DocumentiActions.changeSelectedTab(idTab));
        },
        getDataSourceLista() {
            return dispatch(DocumentiActions.getDataSourceLista());
        },
        setIsInEditMode(mod) {
            return dispatch(DocumentiActions.setIsInEditMode(mod));
        },
        eliminaDoc() {
            return dispatch(DocumentiActions.eliminaDoc());
        },
        setIsAlreadyExistingDoc(isAlreadyExistingDoc) {
            return dispatch(DocumentiActions.setIsAlreadyExistingDoc(isAlreadyExistingDoc));
        },
        resetDoc() {
            return dispatch(DocumentiActions.resetDoc());
        },
        scaricaDocument(id) {
            return dispatch(DocumentiActions.scaricaDocument(id));
        },
        getDocumentById(docId) {
            return dispatch(DocumentiActions.getDocumentById(docId));
        },
        inizializzaModificaDocument() {
            return dispatch(DocumentiActions.inizializzaModificaDocument())
        },
        handleChangeParameter(key, value) {
            return dispatch(DocumentiActions.handleChangeParameter(key, value))
        },
        preview() {
            return dispatch(DocumentiActions.stampaPreview())
        },
        validationDocument(key, value) {
            return dispatch(DocumentiActions.validationDocument(key, value))
        },
        resetDocTab() {
            return dispatch(DocumentiActions.resetDocTab())
        },
        toggleShowConfermaNuovaVersione() {
            return dispatch(DocumentiActions.toggleMostraPopupConfermaNuovaVersione());
        },
        pubblicaDocumento(idDocToPublish) {
            return dispatch(DocumentiActions.pubblicaDocumento(idDocToPublish))
        },
        setConfirmPublicDoc(val) {
            return dispatch(DocumentiActions.setConfirmPublicDoc(val))
        },
        setIdDocumentoOrigine(idDocumentoOrigine) {
            return dispatch(DocumentiActions.setIdDocumentoOrigine(idDocumentoOrigine));
        },
        updateIdUltimaVersioneDocumento(newVersionId) {
            return dispatch(DocumentiActions.updateIdUltimaVersioneDocumento(newVersionId));
        }

    }
};

function mapStateToProps(state) {
    return {
        listaDoc: state.documentiReducer.listaDoc,
        nuovoDoc: state.documentiReducer.nuovoDoc,
        tabSelected: state.documentiReducer.tabSelected,
        listaDataSource: state.documentiReducer.listaDataSource,
        isAlreadyExistingDoc: state.documentiReducer.isAlreadyExistingDoc,
        isInEditMode: state.documentiReducer.isInEditMode,
        parametersMap: state.documentiReducer.parametersMap,
        validationDoc: state.documentiReducer.validationDoc,
        showConfermaNuovaVersione: state.documentiReducer.showConfermaNuovaVersione,
        documento: state.documentiReducer.documento,
        versioniDoc: state.documentiReducer.versioniDoc,
        idUltimaVersioneDoc: state.documentiReducer.idUltimaVersioneDoc,
        showConfirmPublicDoc: state.documentiReducer.showConfirmPublicDoc
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NuovoDoc);
